<template>
    <div class="page-table mainDiv" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">
            Kategori İşlemleri
        </div>
        <el-row :gutter="10">
            <el-col :lg="18" :md="18" :sm="24" :xs="24">
                <div class="page-header card-base card-shadow--medium animated fadeInUp">
                    <el-table
                            border
                            stripe
                            :data="kategoriList"
                            style="width: 100%">
                        <el-table-column
                                label="Sıra"
                                type="index"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="kategoriAdi"
                                label="Kategori"
                                width="auto">
                        </el-table-column>
                        <el-table-column
                                label="İşlem"
                                align="right"
                                width="auto">
                            <template slot-scope="scope">
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.duzenle")'
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-on:click="selectionIndex=scope.$index; selection=scope.row; updateStart(scope.row); "
                                            type="text"
                                            class="buttonEdit"
                                            icon="el-icon-edit">
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.sil")'
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-on:click="dialogVisible = true; selection=scope.row; selectionIndex=scope.$index"
                                            type="text"
                                            class="buttonDel"
                                            icon="mdi mdi-delete mdi-24px">
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-col>
            <el-col :lg="6" :md="6" :sm="24" :xs="24">
                <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
                    <el-form status-icon :model="kategoriForm" :rules="rulesKategori" ref="kategoriForm"
                             @submit.native.prevent="enter"
                             class="demo-ruleForm">
                        <div>
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Kategori Adı'
                                                  prop="kategoriAdi">:
                                        <el-input
                                                v-model="kategoriForm.kategoriAdi"
                                                placeholder='Kategori Adı Giriniz'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Kategori Adı (İngilizce)'
                                                  prop="kategoriAdiEN">:
                                        <el-input
                                                v-model="kategoriForm.kategoriAdiEN"
                                                placeholder='Kategori Adı Giriniz'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Opsiyon' prop="marka">:
                                        <el-select
                                                multiple
                                                v-model="secilenOpsiyon"
                                                style="width: 100%">
                                            <el-option v-for="item in opsiyonList"
                                                       :key="item.uopsiyonKodu"
                                                       :label="item.baslik"
                                                       :value="item.uopsiyonKodu"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label="İcon" prop="icon">:
                                        <el-upload
                                                action=""
                                                :auto-upload="false"
                                                :limit="1"
                                                accept=".png"
                                                ref="upload"
                                                list-type="picture-card"
                                                :on-change="iconUpload"
                                                :on-remove="iconRemove">
                                            <i slot="default" class="el-icon-plus"></i>
                                        </el-upload>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <el-row class="col-p">
                            <el-form-item>
                                <el-button v-if="btnVisible" size="small"
                                           v-on:click="aracKategoriTanimla('kategoriForm')"
                                           type="primary">
                                    Tanımla
                                </el-button>
                                <el-button v-else size="small" v-on:click="guncelleme('kategoriForm')" type="primary">
                                    Güncelle
                                </el-button>
                                <el-button v-if="!btnVisible" size="small" v-on:click="vazgec('kategoriForm')">
                                    Vazgeç
                                </el-button>
                            </el-form-item>
                        </el-row>
                    </el-form>
                </div>
            </el-col>
        </el-row>
        <el-dialog
                :title='$t("src.views.apps.haberler.liste.uyari")'
                :visible.sync="dialogVisible"
                width="30%"
                center>
            <span>"{{selection["kategoriAdi"]}}" kategorisini silmek istediğinize emin misiniz?</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="sil(selection,selectionIndex,kategoriList), dialogVisible = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="dialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
    import urunService from '../../../../WSProvider/UrunService'
    import notification from '../../../../notification'
    import JQuery from 'jquery';

    let $ = JQuery;
    let base64 = require('base64_js');
    let userDataEstasMil = "";
    export default {
        name: "KategoriIslemleri",
        mounted() {
            this.getKategoriListesi();
            this.getOpsiyonListesi();
        },
        data() {
            return {
                selectIcon: '1',
                radio: '1',
                opsiyonList: [],
                kategoriList: [],
                updateKodu: '',
                btnVisible: true,
                selection: '',
                selectionIndex: '',
                dialogVisible: false,
                duzenleBtnVisible: true,
                VisibleA: false,
                linkVisible: false,
                linkChange: true,
                disabled: false,
                secilenOpsiyon: [],
                kategoriForm: {
                    kategoriAdi: '',
                    kategoriAdiEN: '',
                    icon: '',
                },
                rulesKategori: {
                    kategoriAdi: [{
                        required: true,
                        message: "Lütfen Kategori Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            getKategoriListesi() {
                urunService.kategoriList().then((response) => {
                    if (response.status === 200) {
                        this.kategoriList = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            getOpsiyonListesi() {
                urunService.opsiyonList().then((response) => {
                    if (response.status === 200) {
                        if (response.data.length > 0) {
                            this.secilenOpsiyon.push(response.data[0].uopsiyonKodu);
                        }
                        this.opsiyonList = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            updateStart(scope) {
                urunService.kategoriDetay(scope.ukategoriKodu).then((response) => {
                    if (response.status === 200) {
                        this.kategoriForm.kategoriAdi = response.data.kategoriAdi;
                        if(response.data.dil.en){
                            this.kategoriForm.kategoriAdiEN = response.data.dil.en.kategoriAdi;
                        }
                        this.updateKodu = response.data.ukategoriKodu;
                        this.btnVisible = false;
                    } else {
                        notification.Status(response.status, this)
                    }
                });

            },
            vazgec(formName) {
                this.$refs[formName].resetFields();
                this.btnVisible = true;
            },
            enter() {
                if (this.btnVisible) {
                    this.aracKategoriTanimla('kategoriForm');
                } else this.guncelleme('kategoriForm')
            },
            iconUpload(file, fileList) {
                $('.el-upload--picture-card').hide();
                if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.kategoriForm.baslik) {
                        if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                            var imgname = "urunKategori-" + randomText(7) + '-' + linkTemizle(this.kategoriForm.baslik) + ".jpg";
                        } else {
                            imgname = "urunKategori-" + randomText(7) + '-' + linkTemizle(this.kategoriForm.baslik) + ".png";
                        }
                    } else {
                        if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                            imgname = "urunKategori-" + randomText(7) + '-' + linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".jpg";
                        } else {
                            imgname = "urunKategori-" + randomText(7) + '-' + linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".png";
                        }
                    }
                    this.kategoriForm.icon = imgname;
                    this.sumResimFonk(file, imgname);
                } else {
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            iconRemove() {
                $('.el-upload--picture-card').show();
                this.kategoriForm.icon = "";
            },
            aracKategoriTanimla(formName) {
                var dil = [];
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        dil = {
                            en: this.kategoriForm.kategoriAdiEN
                        };
                        urunService.urunKategoriTanimlama(this.kategoriForm.kategoriAdi, this.kategoriForm.icon, '1', this.secilenOpsiyon,dil).then((response) => {
                            if (response.status === 200) {
                                this.kategoriList.push(response.data);
                                notification.Status('success', this, 'Kategori başarıyla eklendi.');
                                this.$refs[formName].resetFields();
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir model zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            guncelleme(formName) {
                var dil = [];
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        dil = {
                            en: this.kategoriForm.kategoriAdiEN
                        };
                        urunService.urunKategoriGuncelle(this.updateKodu, this.kategoriForm.kategoriAdi, this.kategoriForm.icon,dil).then((response) => {
                            if (response.status === 200) {
                                this.kategoriList.splice(this.selectionIndex, 1);
                                this.kategoriList.splice(this.selectionIndex, 0, {
                                    kategoriAdi: response.data.kategoriAdi,
                                    icon: response.data.icon,
                                    ukategoriKodu: response.data.ukategoriKodu
                                });
                                notification.Status('success', this, 'Kategori başarıyla güncellendi...');
                                this.$refs[formName].resetFields();
                                this.btnVisible = true;
                            } else if (response.status === 200) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir model zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            sil(selection, index, list) {
                urunService.kategoriKaldir(selection.ukategoriKodu).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Kategori başarıyla silindi.');
                        list.splice(index, 1);
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
        }
    }

</script>


<style scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }

</style>